import { AnalyticsStatsRoot } from "./AnalyticsStatsRoot/AnalyticsStatsRoot";
import { AnalyticsStatsTile } from "./AnalyticsStatsTile/AnalyticsStatsTile";

export const Root = AnalyticsStatsRoot;
export const Tile = AnalyticsStatsTile;
